<template>
	<LoginLayout>

		<div v-loading="loading">

			<div ref="cgu" class="cgu" v-html="cgu.text" @scroll="checkScroll" ></div>
			
			<el-row :gutter="40" class="btn-cgu-row">
				<el-col :span="12">
					<el-button type="info" plain icon="fas fa-times" @click="$router.push('/logout')">&nbsp;Annuler</el-button>
				</el-col>
				<el-col :span="12">
					<el-button type="primary" plain icon="fas fa-check" :disabled="disabledBtn" @click="accept">&nbsp;Accepter</el-button>
				</el-col>
			</el-row>
		
		</div>

	</LoginLayout>
</template>

<script>
import LoginLayout from '@/layouts/login.layout.vue'
import CguService from '@/services/cgu.service'

export default {
	name: 'Cgu',
	components: { LoginLayout },
	data: function () {
		return {
			loading: true,
			cgu: {},
			disabledBtn: true
		}
	},
    methods: {
        checkScroll() {
			if (this.disabledBtn && this.$refs.cgu && (this.$refs.cgu.offsetHeight + this.$refs.cgu.scrollTop >= this.$refs.cgu.scrollHeight)) {
				this.disabledBtn = false
  			}
		},
		accept() {

			this.loading = true

			// Appel de l'api
			CguService.accept(this.cgu.id).then(() => {

				this.loading = false
				this.$router.push('/dashboard')

			})

		}
	},
	mounted: function() {

		// Appel de l'api
		CguService.getLast().then((cgu) => {

			if (cgu.alreadyAccepted) {
				this.$router.push('/dashboard')
			} else {
				this.cgu = cgu
				this.loading = false
			}
			this.$nextTick(() => { 
				this.checkScroll();
			})
		})
	
	}


	
}
</script>

<style>

.login-card {
    padding-top: 30px;
    padding-bottom: 30px;
}

.cgu {
	overflow-y: scroll;
	min-height: 100px;
	max-height: 300px;
	border: 1px solid #c6d9eb;
}

.btn-cgu-row {
	margin-top: 20px;
}

.btn-cgu-row button {
	width: 100%;
}

</style>